import { Pcr } from '../../lib/types/models/pcr/pcr'
import { StaffApplicationEvaluationInput } from '../../lib/types/models/staff-application/staff-application-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const changeStaffApplicationEvaluation = ({
  id,
  ...data
}: IdInput<StaffApplicationEvaluationInput>) => {
  return restApiClient
    .url(constructApiUrl(API.candidate.changeApplicationEvaluation.url, { id }))
    .patch<Pcr, StaffApplicationEvaluationInput>(data)
}
